import React from "react";
import { Stack, TextField, Typography } from "@mui/material";

const normalizeArray = (a) => (Array.isArray(a) ? a : []);

const QuestionFormDnD = ({ value, onChange }) => {
    const v = value || {};
    const words = normalizeArray(v.initialWords);

    function setWord(idx, patch) {
        const next = words.map((w, i) => (i === idx ? { ...w, ...patch } : w));
        onChange({ ...v, initialWords: next });
    }

    function addWord() {
        onChange({
            ...v,
            initialWords: [...words, { id: Date.now(), text: "", type: "leftBucket" }],
        });
    }

    function removeWord(idx) {
        onChange({ ...v, initialWords: words.filter((_, i) => i !== idx) });
    }

    return (
        <Stack spacing={2}>
            <TextField
                label="question (HTML)"
                value={v.question || ""}
                onChange={(e) => onChange({ ...v, question: e.target.value })}
                fullWidth
                multiline
                minRows={4}
            />

            <TextField
                label="leftBucketTitle"
                value={v.leftBucketTitle || ""}
                onChange={(e) => onChange({ ...v, leftBucketTitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="centerBucketTitle"
                value={v.centerBucketTitle || ""}
                onChange={(e) => onChange({ ...v, centerBucketTitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="rightBucketTitle"
                value={v.rightBucketTitle || ""}
                onChange={(e) => onChange({ ...v, rightBucketTitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="bucketsAmount"
                type="number"
                value={v.bucketsAmount ?? 2}
                onChange={(e) => onChange({ ...v, bucketsAmount: Number(e.target.value) || 2 })}
                fullWidth
            />

            <Typography variant="subtitle2">initialWords</Typography>

            {words.map((w, idx) => (
                <Stack key={idx} direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <TextField
                        label="id"
                        value={w.id ?? ""}
                        onChange={(e) => setWord(idx, { id: Number(e.target.value) || e.target.value })}
                        sx={{ width: { sm: 140 } }}
                    />
                    <TextField
                        label="text"
                        value={w.text || ""}
                        onChange={(e) => setWord(idx, { text: e.target.value })}
                        fullWidth
                    />
                    <TextField
                        label="type"
                        value={w.type || "leftBucket"}
                        onChange={(e) => setWord(idx, { type: e.target.value })}
                        placeholder="leftBucket / centerBucket / rightBucket"
                        sx={{ width: { sm: 220 } }}
                    />
                    <TextField
                        value="✕"
                        onClick={() => removeWord(idx)}
                        sx={{ width: { sm: 60 }, "& input": { cursor: "pointer", textAlign: "center" } }}
                        inputProps={{ readOnly: true }}
                    />
                </Stack>
            ))}

            <TextField
                value="+ add word"
                onClick={addWord}
                inputProps={{ readOnly: true }}
                sx={{ "& input": { cursor: "pointer" } }}
            />
        </Stack>
    );
};

export default QuestionFormDnD;
